<template>
  <Content id="roles">
    <div slot="search">

      <Form :label-width="70" :model="formItem">
        <Row :gutter="13">
          <Col>
            <FormItem  label="幼儿园"  prop="kindergartenId" :label-width="60">
              <el-select v-model.trim="formItem.kindergartenId" placeholder="幼儿园"
                         clearable filterable
                         size="small"
                         transfer="true"
                         :popper-append-to-body="false"
                         style="width: 300px;">
                <el-option v-for="item in kindergartenList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"
                           @click.native="handleKindergartenChange(item)"
                           style="width:300px;z-index: 9999;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="类型" :label-width="45">
              <Select v-model="formItem.type" style="width:80px ;">
                <Option value="">全部</Option>
                <Option value="1">ABC表</Option>
                <Option value="2">CONNERS表</Option>
                <Option value="3">M-CHAT-R表</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态" :label-width="45">
              <Select v-model="formItem.status" style="width:80px ;">
                <Option value="" >全部</Option>
                <Option value="1" >生成中</Option>
                <Option value="2" >已生成</Option>
                <Option value="3" >已下载</Option>
              </Select>
            </FormItem>
          </Col>
          <!--
          <Col>
            <FormItem label="操作时间" :label-width="110">
              <DatePicker  style="width:114px ;" type="date" :editable="false" placeholder="起始日期" format="yyyy-MM-dd" v-model="search.startDate"  @on-change="changestart"></DatePicker>
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd" v-model="search.endDate" @on-change="changeend"></DatePicker>
            </FormItem>
          </Col>
          -->
          <Col>
            <div style="display:flex;">
              <Button type="primary" @click="handleDataList">搜索</Button>&nbsp;
            </div>
          </Col>
        </Row>
      </Form>
    </div>

    <Row :gutter="24" class="tableCell" style="margin-top: -20px;margin-bottom: 10px;margin-left: 2px;margin-right: 10px;">
      <Col class="col-cell" v-for="(item, index) in [24]" :span="item"
           style="border: #ffe8c5 solid 1px;height:35px;line-height:35px;background-color: #fff9f0;">
        <slot v-for="i in 1" :name="'inner'+i" v-if="(index+1) === i">
          <Icon type="ios-cube"/>  <span style="text-align: left;color: #f3673d;">下载完成后自动失效,并且只保留最近3天下载记录</span>
        </slot>
      </Col>
    </Row>

    <Table :columns="columns" :data="list.data" ref="table"
           highlight-row
           :row-class-name="tableRowClassName"
           :max-height="tableHeight">

      <template slot-scope="{row}" slot="fileName">
        {{row.fileName.replace(row.fileName.substring(row.fileName.lastIndexOf("_"), row.fileName.lastIndexOf(".")), "")}}
      </template>

      <template slot-scope="{row}" slot="status">
        <span style="color:red;" v-if="row.status === 1">生成中...</span>
        <span style="color:#52c41a;" v-else-if="row.status === 2">已生成</span>
        <span style="color:rgba(77,78,77,0.49);" v-else-if="row.status === 3">已下载</span>
        <span style="color:red;" v-if="row.status === 4">生成失败</span>
        <span style="color:rgba(243,103,61,0.88);" v-else-if="row.status === 5">正在下载中...</span>
      </template>

      <template slot-scope="{row}" slot="operation">
          <a @click.stop="download($event, row)" v-if="row.status == 2">下载文件</a>&nbsp;&nbsp;
      </template>
    </Table>

    <Page class="page" placement="top"
          show-total show-elevator show-sizer :total="pageList.total"
          :current="pageList.currentPage" :page-size="pageList.pageSize"
          :page-size-opts="[100, 150, 300, 500]"
          @on-change="chagecurrent" @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

  </Content>
</template>
<script>
import {
  _getSelectPages, getDownload
} from "@/services/batchLog/batchOutputLog";
import {_kindergartens} from "@/services/manage/kindergartens";
import dayjs from "dayjs";
export default {
  name: "BatchOutputLog",
  data() {
    return {
      // 表单数据
      formItem: {
        kindergartenId:"",
        type:"",
        status:"",
        endDate:dayjs().format('YYYY-MM-DD'),
        startDate:dayjs().format('YYYY-MM-DD')
      },
      kindergartenList:[],
      pollCount: 0,
      list: {
        data: [],
        loading: false
      },
      pageList:{
        currentPage:1,
        pageSize:100,
        total: 0,
      },
      patientIds:'',
      currentRowIndex: null,
      tableHeight: 0,
      gzTempalte : false,
      szTempalte : false,
      fsTempalte : false,
      userType:"",
      disabled: false,
      columns: [
        {
          title: "类型",
          key: "type",
          minWidth: 100,
          render: (h, params) =>
            h('span', params.row.type === 1 ? "ABC表" : params.row.type === 2 ? "CONNERS表" : "M-CHAT-R表")
        },
        {
          title: "幼儿园",
          key: "kindergartenName",
          minWidth: 250
        },
        {
          title: "文件名称",
          slot: "fileName",
          minWidth: 250
        },
        {
          title: "用时(s)",
          key: "times",
          minWidth: 60
        },
        {
          title: "数量",
          key: "quantity",
          minWidth: 60
        },
        {
          title: "状态",
          slot: "status",
          minWidth: 80
        },
        {
          title: "操作时间",
          key: "createTime",
          minWidth: 150
        },
        {
          title: "操作",
          align: "center",
          minWidth: 200,
          slot: 'operation',
        }
      ]
    };
  },
  created() {
      this.tableHeight = window.innerHeight - 300;
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.kindergartens();
      this.handleDataList();
    }
  },
  methods: {
    kindergartens(){
      _kindergartens().then(res => {
        if (res && res.errcode && res.errcode === 1){
          this.kindergartenList = res.data;
        }
      }).catch(() => {});
    },
    handleKindergartenChange(item) {
      this.formItem.kindergartenId = item.id;
    },
    handleDataList() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      let _this = this;
      this.$Loading.start();
      this.list.loading = true;

      this.patientIds = "";
      _getSelectPages({
          ...this.formItem,
          ...this.pageList,
        }).then(res => {
          this.$Loading.finish();
        if (res && res.errcode && res.errcode === 1){
            const { records, total} = res.data;
            this.list = {
              data: records,
              total: total,
              loading: false
            };

            if(total > 0 && records[0].status !== 1){
              _this.pollCount++;
            }else if(total === 0){
              _this.pollCount = 5;
            }
          } else{
            _this.pollCount = 5;
            this.$message({
              type: 'error',
              message: res.errmsg,
              duration: 4000
            });
          }
        }).catch(() => {
          this.$Loading.error();
          this.list.loading = false;
        });
    },
    download(event, item){
      if(item.status === 1) {
        this.$message.warning('正在生成中不能下载');
        return;
      }else if(item.status === 3) {
        this.$message.warning('文件已失效');
        return;
      }
      item.status === 5;

      let _this = this;
      getDownload({id: item.id},'application/octet-stream',function (){

      }, function (){
        _this.$message.success('下载完成');
        _this.handleDataList();
      }).then(res => {
      }).catch(() => {
        _this.$message.info('下载失败');
        _this.handleDataList();
      }).finally(() => {
      })
    },
    tableRowClassName(row, rowIndex) {
      row.index = rowIndex;
      if (this.currentRowIndex === rowIndex) {
        return "success-row";
      }
    },
    chagecurrent(e){
      this.pageList.currentPage=e
      this.getpatienList()
    },
    chagepagesize(e){
      this.pageList.pageSize=e
      this.getpatienList()
    },
    changestart(e){
      this.formItem.startDate=e
    },
    changeend(e){
      this.formItem.endDate=e
    },
  },
};
</script>
<style lang="postcss" scoped>
</style>
